<template>
  <v-main class="omni-error-background omni-box-center secondary text-center">
    <v-container class="error-container">
      <img
        src="https://cloudfront.eleventickets.com/omni/Eleven_360_Positivo_Horizontal.png"
        width="500px"
        alt
        class="animate__animated animate__fadeInDown"
      />
      <div
        class="animate__animated animate__fadeInUp animate__delay-1s error-container-2"
      >
        <h2 class="error-title">Página não encontrada</h2>
        <v-btn height="45" to="/home" class="error-navlink button button-bg">
          <span class="teste error-btn-text button-bg">
            Continuar navegando
          </span>
        </v-btn>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "error",
  metaInfo: {
    title: "Página não encontrada | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Página não encontrada | ElevenTickets",
      },
    ],
  },
  data: () => ({}),
};
</script>

<style scoped>
.omni-error-background {
  background-color: #c9c9c9;
}
.omni-box-center {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999999999;
}

.error-container {
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.error-container-2 {
  padding-top: 10rem;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}

.error-title {
  color: #353535;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.error-navlink {
  color: var(--dl-color-gray-white);
  height: 50px;
  width: 230px;
  display: flex;
  border-width: 0;
  border-radius: 0.625rem;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
  padding-top: 1rem;
}
</style>
